import React from 'react';
import { connect } from 'react-redux';
import { Button, Modal } from 'react-bootstrap';
import { isClipboardAvailable, writeToClipboard } from '../common/clipboardUtils';
import * as modalsActions from '../store/modalsSlice';
import { modalSelectors } from '../store/modalsSlice';

const ModalMessage = (props) => {
  const onHide = () => {
    if (props.payload.onHide) {
      props.payload.onHide();
    }
    props.hideModalMessage();
  }

  return (
    <Modal show={props.isShown} bsSize="small" onHide={onHide} backdrop="static">
      <Modal.Header>
        <Modal.Title>{props.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!props.text ? null : props.text.split('\n').map(textLine => <p key={textLine}>{textLine}</p>)}
      </Modal.Body>
      <Modal.Footer>
        {isClipboardAvailable() ? <Button onClick={writeToClipboard(props.text)}>Copy to clipboard</Button> : <React.Fragment />}
        <Button onClick={onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
}

const mapStateToProps = (state) => modalSelectors.state(state);

const actionCreators = {
  hideModalMessage: modalsActions.hideModalMessage,
};

export default connect(mapStateToProps, actionCreators)(ModalMessage);



// WEBPACK FOOTER //
// ./src/containers/modalMessage.js